<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  preview: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const sourceTypeLabel = source =>
  source.type === 'team'
    ? t('BROADCASTS.COMPOSER.SOURCE.TEAM_TITLE')
    : t('BROADCASTS.COMPOSER.SOURCE.IDENTIFIERS_TITLE');

const operationLabel = source =>
  source.operation === 'include'
    ? t('BROADCASTS.COMPOSER.SOURCE.INCLUDE')
    : t('BROADCASTS.COMPOSER.SOURCE.EXCLUDE');
</script>

<template>
  <div
    class="flex flex-col gap-4 rounded-xl border border-n-teal-7 bg-n-teal-2 p-4"
  >
    <div>
      <h4 class="text-sm font-medium text-n-slate-12">
        {{ t('BROADCASTS.COMPOSER.PREVIEW.TITLE') }}
      </h4>
      <p class="mt-1 text-xs text-n-slate-11">
        {{ t('BROADCASTS.COMPOSER.PREVIEW.ADVISORY') }}
      </p>
    </div>

    <div class="grid gap-3 sm:grid-cols-3">
      <div class="rounded-lg bg-n-solid-2 p-3">
        <div class="text-xs text-n-slate-10">
          {{ t('BROADCASTS.COMPOSER.PREVIEW.INCLUDED') }}
        </div>
        <div class="text-lg font-medium text-n-slate-12">
          {{ preview.summary.included_before_exclusions }}
        </div>
      </div>
      <div class="rounded-lg bg-n-solid-2 p-3">
        <div class="text-xs text-n-slate-10">
          {{ t('BROADCASTS.COMPOSER.PREVIEW.EXCLUDED') }}
        </div>
        <div class="text-lg font-medium text-n-slate-12">
          {{ preview.summary.excluded }}
        </div>
      </div>
      <div class="rounded-lg bg-n-solid-2 p-3">
        <div class="text-xs text-n-slate-10">
          {{ t('BROADCASTS.COMPOSER.PREVIEW.TOTAL') }}
        </div>
        <div class="text-lg font-medium text-n-teal-11">
          {{ preview.summary.total_targets }}
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <div
        v-for="source in preview.sources"
        :key="source.key"
        class="flex flex-wrap items-center gap-x-4 gap-y-1 rounded-lg bg-n-solid-2 px-3 py-2 text-xs text-n-slate-11"
      >
        <span class="font-medium text-n-slate-12">
          {{ operationLabel(source) }} · {{ sourceTypeLabel(source) }}
        </span>
        <span>
          {{
            t('BROADCASTS.COMPOSER.PREVIEW.CANDIDATES', {
              count: source.candidate_count,
            })
          }}
        </span>
        <span>
          {{
            t('BROADCASTS.COMPOSER.PREVIEW.UNIQUE_CONTRIBUTION', {
              count: source.unique_contribution,
            })
          }}
        </span>
      </div>
    </div>
  </div>
</template>
